import DTO from './DTO';
import ListType from './converters/ListType';
import ObjectType from './converters/ObjectType';

class HostStatusHistoryDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: [],
        labelKey: 'id',
      },
      {
        name: 'name',
        type: String,
        validators: [],
        labelKey: 'name',
      },
      {
        name: 'zbx_hostid',
        type: String,
        validators: [],
        labelKey: 'zbx_hostid',
      },
      {
        name: 'host',
        type: String,
        validators: [],
        labelKey: 'host',
      },
      {
        name: 'zbx_address',
        type: String,
        validators: [],
        labelKey: 'zbx_address',
      },
      {
        name: 'status',
        type: Number,
        validators: [],
        labelKey: 'status',
      },
      {
        name: 'status_histories',
        type: ListType(ObjectType([
          {
            name: 'label',
            type: String,
            validators: [],
            labelKey: 'label',
          },
          {
            name: 'scaled_time',
            type: String,
            validators: [],
            labelKey: 'scaled_time',
          },
          {
            name: 'scaled_time_end',
            type: String,
            validators: [],
            labelKey: 'scaled_time_end',
          },
          {
            name: 'host_id',
            type: String,
            validators: [],
            labelKey: 'host_id',
          },
          {
            name: 'status',
            type: String,
            validators: [],
            labelKey: 'status',
          },
        ])),
        validators: [],
        labelKey: 'parking.meter.zbx_location_lat',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      id: this.id,
      host: this.host,
    };
  }
}

export default HostStatusHistoryDTO;
